import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { HPBListPresenter } from "./presenter";
import { useHPBListQuery } from "../../model";

type Props = {
	hotelID: string;
};

export const HPBListContainer = ({ hotelID }: Props) => {
	const { data } = useHPBListQuery({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <HPBListPresenter hotelID={hotelID} data={data} />;
};

HPBListContainer.displayName = "HPBListContainer";
